/* ==========================================================================
   NUKKA — product-form.js
   Variant selection (price / availability / gallery), gallery thumbnails.
   Add-to-cart submission is handled by cart.js (data-product-form).
   ========================================================================== */
(function () {
  'use strict';
  var N = window.NUKKA || (window.NUKKA = {});

  /* ---------- Async product recommendations ---------- */
  N.register(function (scope) {
    scope.querySelectorAll('product-recommendations[data-url]').forEach(function (el) {
      if (el._init) return; el._init = true;
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('.section, product-recommendations');
          if (section && section.innerHTML.trim()) {
            el.innerHTML = section.innerHTML;
            if (N.initScope) N.initScope(el); // wire up the carousel inside the injected markup
          }
        })
        .catch(function () {});
    });
  });

  /* ---------- Product gallery ---------- */
  N.register(function (scope) {
    scope.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      if (gallery._init) return; gallery._init = true;
      var slides = gallery.querySelectorAll('.product-gallery__slide');
      var thumbs = gallery.querySelectorAll('[data-thumb]');
      function show(index) {
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      gallery.showMedia = function (mediaId) {
        slides.forEach(function (s, i) {
          if (String(s.getAttribute('data-media-id')) === String(mediaId)) show(i);
        });
      };
      // Show only the media that belongs to this variant (plus shared media, which has
      // no data-variants). See product-media-gallery.liquid for how groups are formed.
      gallery.showVariant = function (variant) {
        var grouped = variant.featured_media && Array.prototype.some.call(slides, function (s) {
          return (s.getAttribute('data-variants') || '').split(' ').indexOf(String(variant.id)) > -1;
        });
        function belongs(el) {
          var owners = el.getAttribute('data-variants') || '';
          return !grouped || !owners || owners.split(' ').indexOf(String(variant.id)) > -1;
        }
        slides.forEach(function (s) { s.hidden = !belongs(s); });
        thumbs.forEach(function (t) { t.hidden = !belongs(t); });
        var target = variant.featured_media ? variant.featured_media.id : null;
        var first = -1;
        slides.forEach(function (s, i) {
          if (s.hidden) return;
          if (first === -1) first = i;
          if (target && String(s.getAttribute('data-media-id')) === String(target)) first = i;
        });
        if (first > -1) show(first);
      };
    });
  });

  /* ---------- Variant selection ---------- */
  N.register(function (scope) {
    scope.querySelectorAll('[data-product-form]').forEach(function (form) {
      if (form._init) return; form._init = true;
      var root = form.closest('[data-section-id]') || document;
      var dataEl = root.querySelector('[data-product-json]') || form.querySelector('[data-product-json]');
      if (!dataEl) return;
      var product = JSON.parse(dataEl.textContent);
      var idInput = form.querySelector('[name="id"]');
      var priceEl = root.querySelector('[data-price]');
      var addBtn = form.querySelector('[data-add-to-cart]');
      var addText = addBtn ? addBtn.querySelector('[data-add-text]') : null;
      var gallery = root.querySelector('[data-product-gallery]');

      function currentOptions() {
        var opts = [];
        form.querySelectorAll('[data-option-index]').forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          var checked = group.querySelector('input:checked, [aria-checked="true"]');
          if (checked) opts[idx] = checked.value || checked.getAttribute('data-value');
        });
        return opts;
      }

      function findVariant(opts) {
        return product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function setUnavailableState(group, opts) {
        // Mark options that yield no available variant (sold-out combos)
        group.querySelectorAll('[data-value]').forEach(function (btn) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          var test = opts.slice(); test[idx] = btn.getAttribute('data-value');
          var v = product.variants.find(function (vv) {
            return vv.options.every(function (o, i) { return test[i] == null || o === test[i]; });
          });
          var available = product.variants.some(function (vv) {
            return vv.available && vv.options[idx] === btn.getAttribute('data-value');
          });
          btn.setAttribute('data-soldout', String(!available));
        });
      }

      function update() {
        var groups = form.querySelectorAll('[data-option-index]');
        var variant;
        if (!groups.length) {
          // No variant picker (default-variant product): use the first
          // available variant instead of matching against empty options.
          variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
        } else {
          var opts = currentOptions();
          groups.forEach(function (g) { setUnavailableState(g, opts); });
          variant = findVariant(opts);
        }

        if (!variant) {
          if (addBtn) { addBtn.disabled = true; }
          if (addText) addText.textContent = N.strings.unavailable;
          return;
        }
        if (idInput) idInput.value = variant.id;

        // URL (non-destructive history update)
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }

        // Price
        if (priceEl) {
          var html = N.formatMoney(variant.price);
          var onSale = variant.compare_at_price > variant.price;
          if (onSale) {
            var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
            html = '<s class="price__regular">' + N.formatMoney(variant.compare_at_price) + '</s>' +
                   '<span class="price__sale">' + N.formatMoney(variant.price) + '</span>' +
                   (pct > 0 ? '<span class="price__save-badge">Save ' + pct + '%</span>' : '');
          } else {
            html = '<span class="price__current">' + html + '</span>';
          }
          priceEl.innerHTML = '<span class="price' + (onSale ? ' price--sale' : '') + '">' + html + '</span>';
        }

        // Availability
        if (addBtn) {
          addBtn.disabled = !variant.available;
          if (addText) addText.textContent = variant.available ? N.strings.addToCart : N.strings.soldOut;
        }

        // Gallery
        if (gallery && gallery.showVariant) {
          gallery.showVariant(variant);
        }

        form.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
      }

      form.addEventListener('change', update);
      form.querySelectorAll('.variant__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('[data-option-index]');
          group.querySelectorAll('.variant__btn').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
          btn.setAttribute('aria-checked', 'true');
          var hidden = group.querySelector('input[type="hidden"]');
          if (hidden) hidden.value = btn.getAttribute('data-value');
          update();
        });
      });
      update();
    });
  });
})();
